<template>
    <div :title="title" @click="dayClicked" v-bind:class="className">
        <div class="day-value">
            {{date.getDate()}}
            
        </div>
        <div class="has-data">
            <div v-if="hasNoise" class="has-noise"></div>
            <div v-if="hasAudio" class="has-audio"></div>
            <div v-if="hasWeather" class="has-weather"></div>
            <div v-if="hasVideo" class="has-video"></div>
            <div v-if="hasAdio"  class="has-adio"></div>
        </div>
        
    </div>
</template>

<style>
    .calendar-item{
        position: relative;
        height: 35px;
        width: 35px;
        float:left;
        text-align: center;
        border-radius: 5%;
        cursor: default;
    }
    .enabled:hover{
        background-color: #525E64;
    }
    .disabled{
        color: #555555;
    }
    .current-day{
        background-color: #22313F;
        overflow: visible;
    }
    .day-value{
        position: absolute;
        top: 50%;
        left:50%;
        transform: translate(-50%,-50%);
    }
    .has-data{
        position: absolute;
        bottom: 2px;
        left: 2px;
    }
    .has-audio{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float:left;
        background-color: #E7505A;
    }
    .has-noise{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float:left;
        background-color: #4C87B9;
    }
    .has-weather{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float:left;
        background-color:#13CE66;
    }
    .has-video{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float:left;
        background-color:#F7BA2A;
    }
    .has-adio{
        margin: 1px;
        height:4px;
        width: 4px;
        border-radius: 50%;
        float:left;
        background-color:#daff00;
    }
</style>

<script>
import {setSelectedDay} from '../../store/actions';
import { mapGetters } from 'vuex'
import * as utils from '../../common/utils'

export default {
    props:['date', 'current'],
    data(){
        return{
            hasAudio: false,
            hasNoise: false,
            hasWeather: false,
            hasVideo: false,
            hasAdio:false,
            enabled: false,
        }
    },
    computed:{
         ...mapGetters([
            'getActiveDays',
            'getSelectedDay'
        ]),
        className:function(){
            var searchableFormat = this.date.getFullYear()+'-'+utils.doubleDigit(this.date.getMonth()+1)+'-'+utils.doubleDigit(this.date.getDate());
            
            var styleName = "calendar-item";
            if(this.getActiveDays[searchableFormat] && this.date.getMonth() == this.current.month) {
                styleName += ' enabled';
                this.enabled = true;
                this.hasNoise = this.getActiveDays[searchableFormat].noise;
                this.hasAudio = this.getActiveDays[searchableFormat].audio;
                this.hasWeather = this.getActiveDays[searchableFormat].weather;
                this.hasVideo = this.getActiveDays[searchableFormat].video;
                this.hasAdio = this.getActiveDays[searchableFormat].adio;
            }
            else {
                styleName += ' disabled'
                this.enabled = false;
                this.hasNoise = false;
                this.hasAudio = false;
                this.hasWeather = false;
                this.hasVideo = false;
                this.hasAdio = false;

            }
            if(this.date.getDate() ==this.getSelectedDay.day 
                && this.date.getMonth() == this.getSelectedDay.month
                && this.date.getFullYear() == this.getSelectedDay.year ) styleName += ' current-day'
            return styleName;
    
        },
        title:function(){
            var output = ''
            if(this.hasNoise) output = output+this.$l('calendar/noise')+
`
`
            if(this.hasAudio) output = output+this.$l('calendar/audio')+
`
`
            if(this.hasWeather) output = output+this.$l('calendar/weather')+
`
`
            if(this.hasVideo) output = output+this.$l('calendar/video')+
`
`
            if(this.hasAdio) output = output+this.$l('calendar/adio')+
`
`
            return output;

        }
    }, 
    methods:{
        dayClicked:function(){ 
            if(!this.enabled) return;
            setSelectedDay(this.$store, {day: this.date.getDate(), month:this.date.getMonth(), year:this.date.getFullYear() })
            if(this.$route.fullPath != '/' && this.$route.fullPath != '/statistics')
                this.$router.push('/');
             //this.selectedDay.day=this.date.getDate() 
             //this.selectedDay.month=this.date.getMonth();
             //this.selectedDay.year=this.date.getFullYear();
             //this.current.month=this.selectedDay.month;
             //this.current.year=this.selectedDay.year;
        }
    }
}
</script>





// WEBPACK FOOTER //
// CalendarDay.vue?36d9ca9e